import { lang } from 'src/utils';

export const ACCESSIBILITY_SETTINGS_LABELS = {
  autoscale: lang.autoScale,
  indoorDefaultTheme: lang.indoor,
  outdoorDefaultTheme: lang.outdoor,
  mcCafeDefaultTheme: lang.mcCafe,
  digitalMerchandiserDefaultTheme: lang.digitalMerchandiser,
};
